import gql from 'graphql-tag';

export default gql`
  mutation deleteDesignProfile($id: Int!) {
    delete_design_profiles_by_pk(profile_id: $id) { profile_id }
  }
`;
